<template>
    <div class="modal-container" @click.self="hideModal">
        <div class="modal-inner-container">
            <div class="image" v-bind:style="{'background-image': 'url(' + data.posts[selectedPostId].imageUrl + ')'}">
            </div>
            <div class="content">
                <div class="description">
                    {{data.posts[selectedPostId].modalDescription ? getCaption(data.posts[selectedPostId].modalDescription) : getCaption(data.settings.modalDescription)}}
                </div>
                <div class="action">
                    <div class="button" v-on:click="performAction">
                        {{data.posts[selectedPostId].modalAction ? data.posts[selectedPostId].modalAction : data.settings.modalButton}}
                    </div>
                </div>
            </div>
            <div class="modal-close-button">
                <img @click.self="hideModal" src="https://cdn2.iconfinder.com/data/icons/filled-icons/493/x-128.png">
            </div>
        </div>
    </div>
</template>

<script>
    import StatsService from "../Services/StatsService";

    export default {
        name: 'InstagramModal',
        props: ['data', 'widgetId'],
        data: function() {
            return {
                selectedPostId: 0
            }
        },
        methods: {
            getCaption(caption) {
                let trimmedCaption = caption.substr(0, 350)

                if (trimmedCaption < caption) {
                    trimmedCaption += ' ....'
                }

                return trimmedCaption
            },
            async performAction() {
                await StatsService.actionPerformed({widgetId: this.widgetId, postId: this.data.posts[this.selectedPostId].id})

                // const actionType = this.data.posts[this.selectedPostId].actionType
                let action = this.data.posts[this.selectedPostId].action
                if (!action) action = this.data.settings.action
                window.top.postMessage({event: 'redirect', url: action}, "*")
            },
            hideModal() {
                const urlParams = new URLSearchParams(window.location.search);
                const iframeID = urlParams.get('iframeID');

                window.top.postMessage({event: 'closeModal', id: iframeID}, "*")
            }
        },
        async mounted() {
            window.addEventListener('message', async (e) => {
                if (typeof(e.data) !== 'object') return
                if (e.data.event === 'setSelectedPostId') {
                    this.selectedPostId = e.data.postId
                    await StatsService.postClicked({widgetId: this.widgetId, postId: this.data.posts[this.selectedPostId].id})
                }
            })
            document.body.addEventListener('keydown', (e) => {
                if(e.key == "Escape"){
                    this.hideModal()
                }
            })

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 100000000;
        /*opacity: 0.8;*/
    }
    .modal-container:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: black;
        z-index: -1;
        opacity: 0.7;
    }
    .modal-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .modal-inner-container {
        position: relative;
        display: flex;
        background: white;
        width: 90%;
        max-width: 900px;
        height: 70%;
        max-height: 500px;
        border-radius: 5px;
        overflow: hidden;
        font-size: 2vh;
    }
    .modal-inner-container .modal-close-button {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .modal-inner-container .modal-close-button img {
        cursor: pointer;
        width: 25px;
        height: 25px;
    }
    .modal-inner-container .image, .content {
        display: inline-flex;
        width: 50%;
        height: 100%;
        flex-direction: column;
    }
    .modal-inner-container .image {
        background-size: cover;
        background-position: center;
    }
    .modal-inner-container .image {
        flex-direction: column;
    }
    .modal-inner-container .content .description,
    .modal-inner-container .content .action{
        height: 50%;
        padding: 50px;

    }
    .modal-inner-container .content .description {
        display: flex;
        justify-content: center;
        align-content: center;
        color: gray;
        line-height: 1.5;
    }
    .modal-inner-container .content .action {
        display: flex;
        align-items: flex-end;
        justify-content: center;
    }
    .modal-inner-container .content .action .button {
        display: flex;
        background: darkgreen;
        padding: 10px 30px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 10px;
        font-weight: bold;
        color:white;
    }
    @media screen and (max-width: 600px) {
        .modal-inner-container .image {
            display: none;
        }
        .modal-inner-container .content {
            width: 100%;
        }
    }
</style>
